class BindHtmlCompileDirective {
    constructor($compile) {
        this.restrict = 'A';
        this.$compile = $compile;
    }

    link(scope, element, attrs) {
        scope.$watch(() => {
            return scope.$eval(attrs.bindHtmlCompile);
        }, (value) => {
            // Incase value is a TrustedValueHolderType, sometimes it
            // needs to be explicitly called into a string in order to
            // get the HTML string.
            element.html(value && value.toString());
            // If scope is provided use it, otherwise use parent scope
            var compileScope = scope;
            if (attrs.bindHtmlScope) {
                compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            this.$compile(element.contents())(compileScope);
        });
    }

    static directiveFactory($compile) {
        'ngInject';
        return new BindHtmlCompileDirective($compile);
    }
}

export default BindHtmlCompileDirective;
